class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    this.updatePosition();
    this.classList.remove('back-to-top--hidden');

    this.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

    document.addEventListener('backToTop:updatePosition', () => {
      this.updatePosition();
    });

    window.addEventListener('resize', () => {
      this.updatePosition();
    });

    const observer = new MutationObserver((mutationList, observer) => {
      const captcha = document.querySelector('.grecaptcha-badge');

      if (document.contains(captcha)) {
        this.style.bottom = `calc(2rem + ${captcha.offsetHeight}px)`;
        document.dispatchEvent(new CustomEvent('footer:updatePadding'));
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  updatePosition() {
    let bottom = 0;
    const stickyBars = document.querySelectorAll('.js-sticky-bar');
    const captcha = document.querySelector('.grecaptcha-badge');

    stickyBars.forEach((el) => {
      bottom += el.offsetHeight;
    });

    if (captcha) {
      bottom += captcha.offsetHeight;
    }

    if (captcha) {
      this.style.bottom = `calc(2rem + ${bottom}px)`;
    } else {
      this.style.bottom = `calc(1rem + ${bottom}px)`;
    }
  }
}

customElements.define('back-to-top', BackToTop);
